import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WSubVerticalHeaderCCD: IClientComponentDefinition = {
  name: 'WSubVerticalHeader',
  load: () =>
    import(/* webpackChunkName: 'WSubVerticalHeader' */ './w-sub-vertical-header.component'),
}
